import { render } from "./CompanyStats.vue?vue&type=template&id=4cb2eb92"
import script from "./CompanyStats.vue?vue&type=script&lang=js"
export * from "./CompanyStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__